import { render, staticRenderFns } from "./BaseTHeadTH.vue?vue&type=template&id=5623420e&"
import script from "./BaseTHeadTH.vue?vue&type=script&lang=js&"
export * from "./BaseTHeadTH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports